import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import ModalContainer from '../../components/ModalContainer.jsx';
import { Form, Formik } from 'formik';
import { initialTouched, initialValues, onSubmit, validationSchema } from './editServiceFormikCodes.js';
import GetField from '../../components/GetField.jsx';
import DeleteIcon from '@mui/icons-material/Delete';
import { deletePhase, getSingleServiceDataService } from '../../services/servicesServices.js';
import Alert from '../../utils/Alert.js';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Button, IconButton, Tooltip } from '@mui/material';

const options = [
    {
        text: "جاری",
        value: "o"
    },
    {
        text: "تایید شده",
        value: "a"
    },
    {
        text: "رد شده",
        value: "r"
    },
    {
        text: "منقضی",
        value: "e"
    }
];

const EditService = () => {
    const [days, setDays] = useState([]);
    const [editingService, setEditingService] = useState(null);
    const [reinitializeValues, setReinitializeValues] = useState(null);

    const navigate = useNavigate();
    const location = useLocation();

    const { setForceRequest } = useOutletContext();

    const handleGetSingleServiceData = async (serviceCode) => {
        try {
            const response = await getSingleServiceDataService(serviceCode);
            if (response.status === 200) {
                setEditingService(response.data);
            }
        } catch (error) {
            Alert(`خطا ${error.response?.status || ""}!`, "در دریافت اطلاعات سرویس مشکلی رخ داده است!\nلطفاً مجدداً تلاش کنید.", "error");
            return navigate(-1);
        }
    }


    useEffect(() => {
        let allDays = [];
        for (let i = 1 ; i <= 30 ; i++) {
            allDays.push({
                text: i,
                value: i
            });
        }
        setDays(allDays);

        if (location.state) {
            handleGetSingleServiceData(location.state.code);
        } else {
            return navigate(-1);
        }
    }, []);

    useEffect(() => {
        if (editingService) {
            setReinitializeValues({
                status: editingService.status || "",
                unit_price: editingService.unit_price || "",
                admin_description: editingService.admin_description || "",
                expire_time: editingService.expire_time || "",
                preparation_time: editingService.preparation_time || "",
                phases: editingService.phases || ""
            });
        }
    }, [editingService]);
    
    return (
        <ModalContainer
            alwaysOpen={true}
            fullscreen={false}
            title={`ویرایش سرویس "${location.state.code}"`}
        >
            <Formik
                initialValues={reinitializeValues || initialValues}
                initialTouched={reinitializeValues ? initialTouched : {}}
                onSubmit={(values, actions) => onSubmit(values, actions, editingService, setForceRequest, navigate)}
                validationSchema={validationSchema}
                enableReinitialize
                validateOnMount
            >
                {(formik) => {
                    const { values, setFieldValue } = formik;

                    const addPhase = () => {
                        setFieldValue('phases', [...values.phases, {title: '', price: '', is_current: false, is_completed: false}])
                    }

                    const removePhase = (index, phaseId) => {
                        if (phaseId) {
                            deletePhase(phaseId).then((res) => {
                                if (res.status === 200) {
                                    const newPhases = values.phases.filter((_, i) => i !== index);
                                    setFieldValue('phases', newPhases);
                                    Alert("انجام عملیات", "فاز با موفقیت حذف شد", "success");  
                                }
                            }).catch((err) => {
                                switch (err.response?.status) {
                                    case 404:
                                        Alert(`خطا ${err.response?.status || ""}!`, "چنین فازی وجود ندارد", "error");
                                        break;
                                    case 400:
                                        Alert(`خطا ${err.response?.status || ""}!`, "امکان حذف فاز تکمیل شده یا اختصاص یافته به یک پیمانکار وجود ندارد", "error");
                                        break;
                                    default:
                                        Alert(`خطا ${err.response?.status || ""}!`, "مشکلی رخ داده است", "error");
                                }
                            })
                        } else {
                            const newPhases = values.phases.filter((_, i) => i !== index);
                            setFieldValue('phases', newPhases);
                        }
                    }

                    return (
                        <Form className="flex flex-col items-center">
                            <div className="mb-5 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="select"
                                    name="status"
                                    options={options}
                                    label="وضعیت سرویس:"
                                    title="وضعیت سرویس را انتخاب کنید"
                                    formik={formik}
                                />
                            </div>
                            <div className="mb-5 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="select"
                                    name="expire_time"
                                    options={days}
                                    label="مدت انقضای سرویس (بر حسب روز):"
                                    title="مدت انقضای سرویس را انتخاب کنید"
                                    formik={formik}
                                />
                            </div>
                            <div className="mb-5 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="preparation_time"
                                    type="number"
                                    placeholder="مدت آماده سازی سرویس"
                                    label="مدت آماده سازی"
                                    formik={formik}
                                />
                            </div>
                            <div className="mb-5 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="unit_price"
                                    type="text"
                                    placeholder="قیمت واحد"
                                    label="قیمت"
                                    formik={formik}
                                />
                            </div>
                            <div className='mb-5 flex w-full md:w-4/6 max-w-screen-sm'>
                                <p className='flex-1'>فازبندی پروژه</p>
                                <Tooltip>
                                    <IconButton sx={{ my: "-0.5rem" }} onClick={addPhase}>
                                        <AddCircleOutlineIcon />
                                    </IconButton>
                                </Tooltip>
                            </div>
                            {values.phases.length === 0 ? (  
                                <p className="text-gray-500 mb-5">فازی تعریف نشده است</p>  
                            ) : (  
                                values.phases.map((phase, index) => (  
                                    <div key={index} className='mb-5 flex w-full md:w-4/6 max-w-screen-sm'>  
                                        <div className='ml-3 w-full'>  
                                            <GetField  
                                                control="input"  
                                                name={`phases[${index}].title`}  
                                                type="text"  
                                                placeholder="عنوان فاز"  
                                                label="عنوان"  
                                                formik={formik}  
                                            />  
                                        </div>  
                                        <div className='ml-3 w-full'>  
                                            <GetField  
                                                control="input"  
                                                name={`phases[${index}].price`}  
                                                type="text"  
                                                placeholder="مبلغ فاز"  
                                                label="مبلغ"  
                                                formik={formik}  
                                            />  
                                        </div>  
                                        <div>
                                            <Tooltip>
                                                <IconButton onClick={() => removePhase(index, phase.id)}>  
                                                    <DeleteIcon className="text-red-400"/>  
                                                </IconButton>  
                                            </Tooltip>
                                            <small className='mt-1 block'></small>
                                        </div>
                                    </div>  
                                ))  
                            )}  
                            <div className="mb-5 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="textarea"
                                    name="admin_description"
                                    label="توضیحات ادمین:"
                                    placeholder="توضیحات ادمین"
                                />
                            </div>

                            <div className="w-full text-center mt-4">
                                <GetField
                                    control="submitbutton"
                                    disabledButton={true}
                                    formik={formik}
                                    text="ویرایش سرویس"
                                />
                            </div>
                        </Form>
                    );
                }}
            </Formik>
        </ModalContainer>
    );
}

export default EditService;
